import { LBInput } from '@linearb/buzz';
import {
  StyledDescription,
  StyledInputWrapper,
  StyledSelectorTitle
} from './ReportedMetricsModal.style';

export const MetricNameInput = ({ modalState, setModalState }) => {
  const MAX_LENGTH = 30;

  return (
    <StyledInputWrapper>
      <StyledSelectorTitle>DISPLAY NAME</StyledSelectorTitle>
      <StyledDescription>
        Provide a clear and descriptive label for the reported metric
      </StyledDescription>
      <LBInput
        onChange={event => {
          setModalState({ ...modalState, metricName: event.target.value });
        }}
        value={modalState.metricName || ''}
        maxLength={MAX_LENGTH}
      />
    </StyledInputWrapper>
  );
};
